import React, { useState } from "react";
import LoanDetails from "../../LoanDetails";
import ClientDetailCTLoanDetail from "../../ClientDetailCTLoanDetail";
import { APIURLCOT } from "../../../Config";
import { toast } from "react-toastify";
import axios from "axios";

export default function ClientDetailsCT() {
  const [activeTab, setActiveTab] = useState("CD");
  const [lid, setLid] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const token = localStorage.getItem("token");
  const [width, setWidth] = React.useState(window.innerWidth < 768);

  const handleSearch = () => {
    setIsLoading(true);
    const loanId = { lid: lid };
    axios
      .request(`${APIURLCOT}/ClientDetails/${lid}`, {
        method: "GET",

        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response::: ", response);
        if (response.data == "No loan card details found.") {
          toast.error(response.data);
          setIsLoading(false);
        } else {
          setShowSearch(true);
          // setLid("");
          setSearchData(response.data.loanid);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };
  return (
    <div>
      <div className={width ? "" : "p-3"}>
        <div>
          <ul className="nav nav-tabs-CT" id="myTabs" role="tablist">
            <li
              className={width ? "nav-item mt-2" : "nav-item"}
              role="presentation"
            >
              <button
                className={`nav-link nav-itm-CT tab-item ${
                  activeTab === "CD" ? "active" : ""
                }`}
                id="CD"
                data-bs-toggle="tab"
                data-bs-target="#CD"
                type="button"
                role="tab"
                aria-controls="summary"
                aria-selected={activeTab === "CD"}
              >
                Client Details
              </button>
            </li>
          </ul>
        </div>
        <div>
          {showSearch ? (
            <>
              <div className="d-flex justify-content-start mt-3">
                <button
                  className="btn btn-secondary"
                  style={{ width: "100px" }}
                  onClick={() => {
                    setShowSearch(false);
                  }}
                >
                  Back
                </button>
              </div>
              <div className=" pt-2">
                <ClientDetailCTLoanDetail lid={lid} />
              </div>
            </>
          ) : (
            <div
              className={`tab-pane fade ${
                activeTab === "CD" ? "show active" : ""
              }`}
              id="CD"
              role="tabpanel"
              aria-labelledby="CD"
            >
              <div className="pt-3">
                <div className="card p-3">
                  <div className="row g-2 align-items-center">
                    <div className="col-12 col-md">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter Loan ID"
                        value={lid}
                        onChange={(e) => setLid(e.target.value)}
                      />
                    </div>
                    <div className="col-12 col-md-auto">
                      <button
                        className="btn btn-outline-dark w-100 w-md-auto text-black bg-white hover:bg-black hover:text-white transition disabled:bg-secondary"
                        onClick={handleSearch}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <div
                            className="spinner-border spinner-border-sm text-dark"
                            role="status"
                          />
                        ) : (
                          "Search"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
